import type { Paywall } from "@/react/types/Paywall";
import type { Space } from "@/react/types/Space";

// Extended paywall interface that includes space and space group assignments
interface PaywallWithAssignments extends Paywall {
  space_group_ids: number[];
  space_ids: number[];
}

export const isAssignedToSpace = (
  paywall: PaywallWithAssignments,
  space: Space,
): boolean => paywall.space_ids.includes(space.id);

const isAssignedToSpaceGroup = (
  paywall: PaywallWithAssignments,
  space: Space,
): boolean => paywall.space_group_ids.includes(space.space_group_id);

export const gatedBy = (
  paywall: PaywallWithAssignments,
  space: Space,
): string => {
  const gatedByMethods: string[] = [];
  if (isAssignedToSpace(paywall, space)) gatedByMethods.push("Space");
  if (isAssignedToSpaceGroup(paywall, space))
    gatedByMethods.push("Space Group");

  return gatedByMethods.join(", ");
};
